<template>
  <!-- <= 750px header -->
  <div class="header-fold" v-if="navFold">
    <div class="header-content">
      <div class="logo" @click="$router.push({ path: '/' })">
        <img src="./../assets/GC.png" alt="logo" height="30" />
      </div>
      <div class="header-right">
        <div class="login">
          <a-button type="primary" @click="handleSignInOrOut">
            {{ $store.state.user.token ? 'Sign out' : 'Sign in' }}
          </a-button>
        </div>
        <a-button
          type="primary"
          style="position: fixed;right: 10px;"
          @click="toggleCollapsed"
        >
          <MenuUnfoldOutlined v-if="collapsed" />
          <MenuFoldOutlined v-else />
        </a-button>
        <div
          style="z-index: 9999;position: fixed;top:60px;right: 0;"
          class="fold-list"
          ref="foldList"
          :style="`height:${clientHeight}px;`"
        >
          <ul v-show="collapsed" :style="`width:${clientWidth}px;`">
            <li
              @click="handleClickNav('account')"
              :class="{ selected: $route.meta.name === 'account' }"
            >
              Home
            </li>
            <li
              @click="handleClickNav('links')"
              :class="{ selected: $route.meta.name === 'links' }"
            >
              Links
            </li>
            <li
              @click="handleClickNav('billing')"
              :class="{ selected: $route.meta.name === 'billing' }"
            >
              Billing Details
            </li>
            <li
              @click="handleClickNav('statistics')"
              :class="{ selected: $route.meta.name === 'statistics' }"
            >
              Dashboard
            </li>
          </ul>
        </div>
      </div>
    </div>

    <SignInModal ref="signInModal"></SignInModal>
    <ContactSalesModal></ContactSalesModal>
  </div>
  <!-- > 750px header -->
  <div class="header-no-fold" v-else>
    <div class="header-content">
      <div class="logo" @click="$router.push({ path: '/' })">
        <img src="./../assets/GC.png" alt="logo" height="30" />
      </div>
      <div class="header-right">
        <div class="nav">
          <div
            :class="{
              'nav-item': true,
              'nav-item-active': $route.meta.name === 'account',
            }"
            @click="handleClickNav('account')"
          >
            Home
          </div>
          <div
            :class="{
              'nav-item': true,
              'nav-item-active': $route.meta.name === 'links',
            }"
            @click="handleClickNav('links')"
          >
            Links
          </div>
          <div
            :class="{
              'nav-item': true,
              'nav-item-active': $route.meta.name === 'billing',
            }"
            @click="handleClickNav('billing')"
          >
            Billing Details
          </div>
          <div
            :class="{
              'nav-item': true,
              'nav-item-active': $route.meta.name === 'statistics',
            }"
            @click="handleClickNav('statistics')"
          >
            Dashboard
          </div>
        </div>
        <div class="login">
          <a-button type="primary" @click="handleSignInOrOut">{{
            $store.state.user.token ? 'Sign out' : 'Sign in'
          }}</a-button>
        </div>
      </div>
    </div>

    <SignInModal ref="signInModal"></SignInModal>
    <ContactSalesModal></ContactSalesModal>
  </div>
</template>

<script>
import SignInModal from '@/components/SignInModal'
import ContactSalesModal from '@/components/ContactSalesModal'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue'
export default {
  name: 'Header',
  components: {
    SignInModal,
    ContactSalesModal,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
  },
  data() {
    return {
      navFold: false,
      collapsed: false,
    }
  },
  mounted() {
    document.body.clientWidth <= 750
      ? (this.navFold = true)
      : (this.navFold = false)
  },
  computed: {
    clientWidth() {
      return document.body.clientWidth
    },
    clientHeight() {
      return document.body.clientHeight
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  watch: {
    collapsed: function(newValue) {
      if (!this.isDesktop && newValue) {
        document.body.style = 'overflow:hidden;'
      } else {
        document.body.style = ''
      }
    },
  },
  methods: {
    handleClickNav(path) {
      if (!this.$store.state.user.token) {
        this.$refs.signInModal.showModal()
      } else {
        this.$router.push({ path: '/' + path })
      }
      this.collapsed = !this.collapsed
    },
    handleSignInOrOut() {
      if (!this.$store.state.user.token) {
        this.$refs.signInModal.showModal()
      } else {
        this.$store.dispatch('user/Logout').then(() => {
          this.$router.push({ path: '/' })
        })
      }
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
      // if (this.collapsed) {
      //   this.$refs.foldList.addClass('.scaleWord')
      // }
      // const clientWidth = document.body.clientWidth
      // const foldList = document.getElementsByClassName('ant-menu-item')
      // if (foldList) {
      //   console.log(foldList)
      //   console.log(clientWidth)
      //   // foldList.offsetWidth = clientWidth
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
/* >750 header */
.header-no-fold {
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: space-around;
  background-color: #fff;

  .header-content {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    .logo {
      height: 70px;
      display: flex;
      align-items: center;
    }

    .header-right {
      display: flex;
      align-items: center;
      user-select: none;

      .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        line-height: 50px;
        margin-right: 20px;
        .nav-item {
          font-size: 16px;
          padding: 10px;
          margin-right: 10px;

          &:hover {
            // background-color: #2486df;
            // color: #fff;
            cursor: pointer;
            border-bottom: 4px solid #2486df;
          }
        }
        .nav-item-active {
          color: #2486df;
          // font-weight: bold;
        }
      }
    }
  }
}
/* <=750 header */
.header-fold {
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: space-around;
  background-color: #fff;

  .header-content {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    overflow: auto;

    .logo {
      height: 60px;
      display: flex;
      align-items: center;
    }

    .header-right {
      display: flex;
      align-items: center;
      user-select: none;

      .login {
        position: fixed;
        right: 66px;
      }

      .ant-btn {
        height: 32px;
        font-size: 18px;
        padding: 0px 12px;
      }

      .fold-list {
        background-color: rgba(255, 255, 255, 0.8);
      }

      ul {
        width: 100%;
        background-color: #1890ff;
      }

      ul,
      li {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      li {
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        padding: 0 0px;
        color: #fff;
        margin: 0;
        border-bottom: 1px solid #fff;
      }

      li.selected {
        color: #1890ff;
        background-color: #e6f7ff;
      }
    }
  }
}
</style>
